import { useAppDispatch } from '../../store/hooks/StoreHooks';
import { setAuditLog, setCatalogdata, setDropdownOption, setFile, setFileError, setFileUploading, setFileUploadProgress, setFileUploadSuccess } from '../../store/equipment-catalog/EquipmentCatalogSlice';
import { DropdownOptions } from '../../utilities/commonUtilities';
import { GetEquipmentCatalogPayload, uploadEquipmentPayload } from '../../store/model/equipment-catalog/catalog';

export const useEquipmentCatalog = () => {
    const dispatch = useAppDispatch();

    const loadEquipmentCatalog = (payload: GetEquipmentCatalogPayload) => {
        return dispatch({ type: "equipmentCatalog/getEquipmentCatalog", payload });
    };

    const loadExportEquipmentCatalog = (payload: GetEquipmentCatalogPayload) => {
        return dispatch({ type: "equipmentCatalog/getExportEquipmentCatalog", payload });
    };

    const updateFile = (payload: any) => {
        return dispatch(setFile(payload));
    };

    const updateFileUploadProgress = (payload: any) => {
        return dispatch(setFileUploadProgress(payload));
    };

    const updateFileUploadSuccess = (payload: any) => {
        return dispatch(setFileUploadSuccess(payload));
    };

    const updateFileError = (payload: any) => {
        return dispatch(setFileError(payload));
    };

    const updateFileUploading = (payload: any) => {
        return dispatch(setFileUploading(payload));
    };

    const validateUploadEquipment = (payload: any) => {
        return dispatch({ type: "equipmentCatalog/validateUploadEquipment", payload });
    };

    const updateExportEquipmentCatalog = (payload: any) => {
        return dispatch({ type: "equipmentCatalog/updateExportEquipmentCatalog", payload });
    };

    const loadAuditLog = (payload: GetEquipmentCatalogPayload) => {
        return dispatch({ type: "equipmentCatalog/getAuditLog", payload });
    };

    const updateDropdownOption = (payload: DropdownOptions) => {
        return dispatch(setDropdownOption(payload));
    };

    const updateCatalogData = (data: any) => {
        return dispatch(setCatalogdata(data));
    };

    const updateAuditLog = (data: any) => {
        return dispatch(setAuditLog(data));
    };

    return {
        loadEquipmentCatalog,
        loadExportEquipmentCatalog,
        updateFile,
        updateFileUploadProgress,
        updateFileUploadSuccess,
        updateFileError,
        updateFileUploading,
        validateUploadEquipment,
        updateExportEquipmentCatalog,
        loadAuditLog,
        updateDropdownOption, 
        updateCatalogData, 
        updateAuditLog 
    };
};